<script>
const daysInWeek = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
const monthsInYear = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];

export default {
  name: "FBarDate",

  props: {
    lastUpdate: {
      type: Number,
      default: null,
    },

    disabledNav: {
      type: Boolean,
      default: false,
    },

    showDay: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: "day",
    },
  },

  data: () => ({
    selectedDate: Date.now(),
  }),

  computed: {
    title() {
      const _selectedDate = new Date(this.selectedDate);

      if (this.type === "month") {
        return `${
          monthsInYear[_selectedDate.getMonth()]
        } / ${_selectedDate.getFullYear()}`;
      }

      const day = daysInWeek[_selectedDate.getDay()];

      return `${day} - ${_selectedDate.toLocaleDateString("pt-BR")}`;
    },

    dateSelectedIstoday() {
      const _selectedDate = new Date(this.selectedDate);

      return (
        _selectedDate.toLocaleDateString() === new Date().toLocaleDateString()
      );
    },

    descriptionLastUpdate() {
      const lastUpdate = new Date(this.lastUpdate);
      const _selectedDate = new Date(this.selectedDate);

      let buffer = lastUpdate.toLocaleTimeString("pt-BR");

      const equals =
        _selectedDate.toLocaleDateString() === lastUpdate.toLocaleDateString();

      if (!equals && this.showDay) {
        buffer += ` em ${lastUpdate.toLocaleDateString("pt-BR")}`;
      }

      return buffer;
    },
  },

  watch: {
    selectedDate: function(date) {
      this.$emit("change", date);
    },
  },

  methods: {
    changeDate(to) {
      const date = new Date(this.selectedDate);

      if (this.type === "month") {
        this.selectedDate = date.setMonth(date.getMonth() + to);
      } else {
        date.setDate(date.getDate() + to);
        this.selectedDate = date.getTime();
      }
    },

    addOneDay() {
      this.changeDate(1);
    },

    subOneDay() {
      this.changeDate(-1);
    },

    reset() {
      this.selectedDate = Date.now();
    },
  },
};
</script>

<template>
  <div class="fluid__bardate">
    <v-btn flat icon :disabled="disabledNav" @click="subOneDay">
      <v-icon large>keyboard_arrow_left</v-icon>
    </v-btn>

    <div class="fluid__bardate__nav__title" @click="reset">
      <span>{{ this.title }}</span>

      <div v-if="this.lastUpdate" class="fluid__bardate__nav__subtitle">
        <span>
          Ultima movimentação ás
          <span>{{ descriptionLastUpdate }}</span>
        </span>
      </div>
    </div>

    <v-btn
      flat
      icon
      :disabled="disabledNav || dateSelectedIstoday"
      @click="addOneDay"
    >
      <v-icon large>keyboard_arrow_right</v-icon>
    </v-btn>
  </div>
</template>

<style scoped>
.fluid__bardate {
  display: flex;
  width: 100%;
  min-height: 47px;
  justify-content: space-around;
  align-items: center;
}

.fluid__bardate__nav__title {
  height: 55px;
  display: flex;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #073d5d;
  cursor: pointer;
}

.fluid__bardate__nav__title:active {
  opacity: 0.6;
}

.fluid__bardate__nav__title > span {
  width: 120px;
  text-align: center;
}

.fluid__bardate__nav__subtitle {
  width: 100%;
  text-align: center;
  font-size: 13px;
}

.theme--dark.application .fluid__bardate__nav,
.theme--dark.application .fluid__bardate__nav__title {
  color: #fff;
}
</style>
